import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {RoleDto} from "../../../../../feature-core/um/model/dto/entity/role.dto";
import {AuthObjectAccessEnum} from "../../../../../feature-core/um/enum/auth-object-access-enum.enum";
import {AuthAssignmentAccessEnum} from "../../../../../feature-core/um/enum/auth-assignment-access-enum.enum";


export class RoleAuthContractDto extends DtoDetail{


    public roleDto? : RoleDto;
    public roleDtoId : number;
    public roleDtoName : string;
    public accessEnum: AuthObjectAccessEnum;
    public assignAccessEnum: AuthAssignmentAccessEnum;
    public viaCustomerAssignment: boolean;
    public viaAgentAssignment: boolean;
    public viaCustomerContractAgentAssignment: boolean;

}